// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"05a5e615","666":"606453aa"}[chunkId] + ".chunk.js";
};